export { default as entryKeyRouting } from './entry-key';
